<template>
    <div class="room__list">
        <div class="room__list_header">
            <view-actions
                v-if="user.isInfrastructureManager()"
                class="custom--table"
                :title="$t('ebs.rooms.list.title.rooms')"
                :cancel-button-active="false"
                :submit-button-text="$t('ebs.rooms.list.buttons.createRooms')"
                @emit-submit="createRoom"
            />
        </div>
        <div class="room__list_main">
          <component-list
              :component-grid="RoomListGrid"
              :component-table="RoomListTable"
              :component-table-name="'rooms'"
              :list-view-items="['table', 'grid']"
              :filter-search-queryable="false"
              :items="rooms"
              :item-name="['room', 'rooms']"
              :table-preferences-active="true"
          />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import RoomListGrid from '@/components/ebs/rooms/list/RoomListGrid'
import RoomListTable from '@/components/ebs/rooms/list/RoomListTable'
import { User } from '@/User'
import ComponentList from '@/components/default/shared/ComponentList'

export default {
  name: 'room-list',
  components: {
    ComponentList,
    ViewActions
  },
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData),
      RoomListTable,
      RoomListGrid
    }
  },
  props: {
    rooms: {
      type: [Array, Object],
      default: () => [],
      required: true
    },
    venueId: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {
    createRoom: function () {
      this.$router.push({ name: 'ebs-room-add', params: { venueId: this.venueId } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/rooms/roomlist";
</style>
